import { PureComponent } from "react";
import colors from "/styles/colors";

import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";

import DirectoryEmptyStateComponent from "../directory-empty-state/directory-empty-state-component";

import ThumbnailsListComponent from "/components/core/lists/thumbnails-list/thumbnails-list-component";
import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import { StyledDirectoryComponent } from "./directory-component.scss";

export default class DirectoryComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.emptyStateRenderer = this.emptyStateRenderer.bind(this);
  }

  emptyStateRenderer() {
    const { emptyStateRenderer } = this.props;
    return emptyStateRenderer ? emptyStateRenderer() : <DirectoryEmptyStateComponent />;
  }

  render() {
    const { tuhmbnailsListData, backgroundColor, thumbnailType, filterTerm, signupForm, filterValidator } = this.props;
    const listData = tuhmbnailsListData.map((item) => item.props);
    const allowSignupForm = signupForm && signupForm.show;

    return (
      <StyledDirectoryComponent className="directory-component" style={{ backgroundColor }}>
        <div className="directory-list-wrapper">
          <ThumbnailsListComponent
            filterTerm={filterTerm}
            tuhmbnailsListData={tuhmbnailsListData}
            thumbnailType={thumbnailType}
            emptyStateRenderer={this.emptyStateRenderer}
            filterValidator={filterValidator}
          />
        </div>

        {allowSignupForm && (
          <div className="directory-signup-wrapper">
            <SignupWithTextComponent title={signupForm.title} subtitle={signupForm.subtitle} />
          </div>
        )}
      </StyledDirectoryComponent>
    );
  }
}

DirectoryComponent.defaultProps = {
  tuhmbnailsListData: [],
  thumbnailType: THUMBNAILS_TYPES.BACKGROUND_COLOR,
  backgroundColor: colors["light-grey"],
  signupForm: {
    show: true,
    title: "Start using monday.com today",
    subtitle: "Try it now for free / No credit card needed"
  }
};
